export default function normalizeBoolean(value) {

    if (value) {
        return (!!value);
    }

    return null;

}